module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABYklEQVRIS+3TP8hOYRjH8c8vJpnEICk2BmaDkGwGKYPe4d1MKAOzWNlYbMqfYpJBKTYWFotisSsiURIunbpfnfffc84Tz/beyzl1X+f7ve7ffZ2Y8cqM+aYSVNVp7MG5JN/HNDdaUFVXcL5Bn+Bokh9DklGCHvwbPmMbHuFYkp+TJIOCqrqGM3iHA/iIx+39AU4k+bWaZFVBVXV7N3AKb3EwyfsOVFUb8BT7cA9zSX6vJFlR0OA3Md/g+5N86AOqaiOeYy9uJelql61lgga/i5N4jUNL4QuUqtqEZ9iN60nOLjUsElTVOtxu8Fc4nOTTpEusqi14gR24muRCv/6voKrW4z6O4yWOJPkyNIbtTra3uLrnxSSXF77rC+Zwp8G7zr+Ogffi2tkkW9v4Puz2+oLN3ch1EU0L70l24VI7xZtFgmm6naZ28EebBjZqTP8VOHFM/zd87Q5GJbo2RYMxzTyiP4aAaRkkCu+DAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/up.png
// module id = 6BN9
// module chunks = 1